import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

export interface MenuTabBarItem {
  id: string;
  name: string;
}

@Component({
    selector: 'app-menu-tab-bar',
    templateUrl: './menu-tab-bar.component.html',
    styleUrls: ['./menu-tab-bar.component.scss'],
    standalone: false
})
export class MenuTabBarComponent implements AfterViewInit, OnChanges {
  @Input() items: MenuTabBarItem[] = [];
  @Input() selectedId: string = '';
  @Output() tabSelected = new EventEmitter<MenuTabBarItem>();
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.scrollToSelected();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedId'] && !changes['selectedId'].firstChange) {
      setTimeout(() => this.scrollToSelected(), 0);
    }
  }

  onTabClick(item: MenuTabBarItem): void {
    this.tabSelected.emit(item);
  }

  private scrollToSelected(): void {
    if (!this.scrollContainer) return;
    const container = this.scrollContainer.nativeElement;
    const activeEl = container.querySelector('.tab-item.active') as HTMLElement;
    if (!activeEl) return;

    const scrollLeft = activeEl.offsetLeft - (container.clientWidth / 2) + (activeEl.clientWidth / 2);
    container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }
}
